import React, { Component } from 'react';
import InputText from '../../blueprintWrappers/InputText';
import IconSmallButton from '../../blueprintWrappers/IconSmallButton';

class EditableDetail extends Component {

	state = {
		editing: false,
	}

	render() {
		return (
			<div className={"EditableDetail"} onKeyPress={this.handleKeyPress}>
				{this.state.editing ? this.edit() : this.show()}
			</div>
		);
	}

	handleKeyPress = (event) => {
		if (event.key === 'Enter') {
			this.toggleEditing();
		}
	}

	toggleEditing = () => {
		this.setState({
			editing: !this.state.editing
		})
	}

	edit = () => {
		const p = this.props;
		if (p.small) {
			return (
				<div>
					<div className="editable_input editable_input_small">
						<InputText
							returnObj={{ attr: p.property }}
							onChange={(text) => p.onChange(text, p.property)}
							placeholder={""}
							value={p.value}
						/>
						<IconSmallButton
							iconName="small-tick"
							title={null}
							onClick={this.toggleEditing}
							classNameAdd='edit_button_inline pt-minimal'
						/>
					</div>
				</div>
			)
		} else {
			return (
				<div>
					<div className="editable_input editable_input_large">
						<InputText
							returnObj={{ attr: p.property }}
							onChange={(text) => p.onChange(text, p.property)}
							placeholder={"type stuff"}
							value={p.value}
						/>
						<IconSmallButton
							iconName="small-tick"
							title={null}
							onClick={this.toggleEditing}
							classNameAdd='edit_button_inline pt-minimal'
						/>
					</div>
				</div>
			)
		}
	}

	show = () => {
		const p = this.props;

		if (p.small) {
			return (
				<div className={"EditableDetailShow"}>
					<div className="editable_line editable_line_small">
						{p.value}
						<IconSmallButton
							iconName="edit"
							title={null}
							onClick={this.toggleEditing}
							classNameAdd='edit_button_inline pt-minimal'
						/>
					</div>
				</div>
			)
		} else {
			return (
				<div>
					<div className="editable_line editable_line_large">
						{p.value}
						<IconSmallButton
							iconName="edit"
							title={null}
							onClick={this.toggleEditing}
							classNameAdd='edit_button_inline pt-minimal'
						/>
					</div>
				</div>
			)
		}

	}



}
export default EditableDetail;


// WEBPACK FOOTER //
// ./src/components/projectmanager/new/EditableDetail.js